"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordToggle = void 0;

var _designLanguage = require("@doordash/design-language");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PasswordToggle = _styledComponents["default"].button.attrs(function () {
  return {
    type: 'button'
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  appearance: none;\n  padding: 0;\n  border: none;\n  background: none;\n  &:focus {\n    ", ";\n  }\n"])), (0, _designLanguage.getFocusStyles)());

exports.PasswordToggle = PasswordToggle;